<div fxLayout *ngIf="user$ | async as user">
  <main fxFlex style="margin-bottom: 0">
    <h1>Good {{ greetingToD }}, {{ user.first_name }}</h1>

    <picture>
      <source srcset="assets/images/demo/dashboard/dashboard.webp" type="image/webp" />
      <img src="assets/images/demo/dashboard/dashboard.svg" class="demo-ux-image" (load)="isImageLoaded = true" />
    </picture>

    <div class="demo-callout rules__intro-text" *ngIf="isImageLoaded">
      <ng-container *ngIf="userTrialConnectAccountCta$ | async as userTrialConnectAccountCta">
        <h2>Welcome to your dashboard!</h2>
        <p class="notification__description">
          The Hospitable.com Dashboard gives you a snapshot of what’s happening with your rental business today and in
          the upcoming weeks. Be on top of check-ins, check-outs, and tasks assigned to your teammates.
        </p>
        <p class="notification__description">
          Connect your {{ userTrialConnectAccountCta?.platformUi | titlecase }} account to import properties into your
          Hospitable.com account and start using the Dashboard today!
        </p>

        <div class="rules__intro-buttons" fxLayout fxLayout.lt-md="column" fxLayoutGap="16px">
          <button mat-flat-button (click)="clickedPrimaryCta(userTrialConnectAccountCta.connectAccountUrl)">
            Connect with {{ userTrialConnectAccountCta?.platformUi | titlecase }}
          </button>

          <a
            mat-flat-button
            class="button__secondary"
            (click)="
              clickedSecondaryCta('https://my.hospitable.com/support-documentation/article/5544651-training-videos')
            ">
            Learn more
          </a>
        </div>
      </ng-container>
    </div>
  </main>
</div>
